import styled from "styled-components";

export const Div = styled.div`
  width: fit-content;
  background-color: var(--color-black);
  border-radius: var(--border-radius-10);
`;

export const Paragraph = styled.p`
  padding: 10px;
  color: var(--color-white);
  font-size: var(--font-size-50);
`;
